import { useEffect, useState } from "react";
import SEO from "@/components/base/SEO";
import SchemaOrg from "@/components/base/SchemaOrg";
import Breadcrumb from "@/components/base/Breadcrumb";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";

const faqData = [
  {
    question: "黑料吃瓜网的内容来源是什么？",
    answer: "我们的内容来源于全网公开信息、网友投稿以及专业娱乐记者的独家爆料。所有内容均经过编辑团队审核把关，确保信息的真实性和可读性。",
  },
  {
    question: "如何向黑料吃瓜网投稿爆料？",
    answer: "您可以通过我们的官方邮箱 contact@heiliachigua.com 提交爆料信息。为保护爆料者隐私，所有投稿均采用匿名处理，我们不会泄露任何投稿人的个人信息。",
  },
  {
    question: "黑料吃瓜网的内容更新频率是怎样的？",
    answer: "我们实行7×24小时全天候监控机制，编辑团队实时追踪娱乐圈动态，确保在热点事件发生后的第一时间为读者呈现最新资讯。平均每日更新超过20篇文章。",
  },
  {
    question: "如何确认爆料内容的真实性？",
    answer: "我们的编辑团队会对每条爆料进行多源交叉验证，包括核实原始信息源、对比多方说法、咨询业内人士等。对于未经证实的传闻，我们会在文章中明确标注。",
  },
  {
    question: "黑料吃瓜网是否会侵犯明星隐私？",
    answer: "我们始终坚持在合法的框架内进行娱乐新闻报道。所有内容均基于已公开的信息和合法渠道获取的素材，我们尊重每位公众人物的合法权益。",
  },
];

export default function AboutPage() {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, []);

  const [formStatus, setFormStatus] = useState<"idle" | "success" | "error">("idle");
  const [formError, setFormError] = useState("");
  const [formUrl, setFormUrl] = useState("");

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const mod = await import("@/mocks/about");
        if (!cancelled) setFormUrl(mod.aboutFormUrl);
      } catch {
        if (!cancelled) setFormUrl("");
      }
    })();
    return () => { cancelled = true; };
  }, []);

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const honeypotEl = form.querySelector<HTMLInputElement>('input[name="company_alt"]');
    if (honeypotEl && honeypotEl.value.trim() !== "") {
      setFormStatus("success");
      form.reset();
      return;
    }

    if (!formUrl) {
      setFormStatus("error");
      setFormError("表单暂不可用");
      return;
    }

    try {
      const formData = new FormData(form);
      const res = await fetch(formUrl, {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: new URLSearchParams(formData as unknown as Record<string, string>).toString(),
      });
      const text = await res.text();
      let parsed: Record<string, unknown> = {};
      try { parsed = JSON.parse(text); } catch { /* raw text */ }

      if (res.ok && parsed?.code === "OK") {
        setFormStatus("success");
        form.reset();
      } else {
        setFormStatus("error");
        const msg = (parsed as Record<string, unknown>)?.meta as Record<string, string> | undefined;
        setFormError(msg?.message || msg?.detail || text || "提交失败，请稍后再试");
      }
    } catch {
      setFormStatus("error");
      setFormError("网络错误，请稍后再试");
    }
  };

  const pageTitle = "关于我们 - 黑料吃瓜网";
  const pageDesc = "黑料吃瓜网品牌介绍、平台口碑与联系方式。了解我们的使命、编辑团队、内容理念与用户评价。";
  const pageKeywords = "黑料吃瓜网,关于我们,品牌介绍,娱乐八卦平台,联系方式";

  return (
    <>
      <SEO
        title={pageTitle}
        description={pageDesc}
        keywords={pageKeywords}
        canonicalUrl="https://heiliachigua.com/about"
        ogType="website"
      />
      <SchemaOrg
        type="WebPage"
        data={{
          name: pageTitle,
          description: pageDesc,
          url: "https://heiliachigua.com/about",
          inLanguage: "zh-CN",
        }}
      />
      <SchemaOrg
        type="FAQPage"
        data={{
          mainEntity: faqData.map((faq) => ({
            "@type": "Question",
            name: faq.question,
            acceptedAnswer: {
              "@type": "Answer",
              text: faq.answer,
            },
          })),
        }}
      />

      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main className="pt-16">
          <div className="max-w-4xl mx-auto px-4 md:px-6 pt-6 pb-12">
            <Breadcrumb
              items={[
                { label: "首页", href: "/" },
                { label: "关于我们" },
              ]}
            />

            <section className="mb-12">
              <h1 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading mb-4">
                🍉 关于黑料吃瓜网
              </h1>
              <div className="flex items-center gap-2 mb-6">
                <span className="text-xs px-3 py-1 rounded-full bg-primary-100 text-primary-600 font-medium">
                  品牌介绍
                </span>
              </div>

              <div className="prose prose-lg max-w-none prose-p:text-foreground-700 prose-p:leading-relaxed">
                <p>
                  黑料吃瓜网成立于2024年，是国内领先的娱乐八卦热点聚合平台。我们致力于为吃瓜群众提供最新、最全、最劲爆的娱乐资讯，打造中文互联网最具影响力的娱乐内容社区。
                </p>
                <p>
                  我们的编辑团队由资深娱乐记者、专业内容策划和数据分析师组成，全天候监控娱乐圈动态，确保用户在第一时间获取最热的八卦资讯。从明星恋情曝光到综艺录制内幕，从影视圈秘闻到网红直播翻车，黑料吃瓜网覆盖娱乐圈的每一个角落。
                </p>
                <p>
                  目前，黑料吃瓜网日均访问量突破百万，已成为中文互联网上最受欢迎的娱乐资讯平台之一。我们始终秉持<strong>真实、及时、有趣</strong>的内容理念，用最接地气的方式讲最劲爆的故事。
                </p>
              </div>
            </section>

            <section className="mb-12 bg-background-100 rounded-lg p-6 md:p-8">
              <h2 className="text-xl md:text-2xl font-bold text-foreground-950 font-heading mb-6">
                🏆 平台口碑
              </h2>
              <div className="grid grid-cols-1 sm:grid-cols-3 gap-5 mb-8">
                <div className="bg-background-50 rounded-lg p-5 text-center">
                  <div className="text-3xl font-bold text-primary-500 font-heading mb-1">100万+</div>
                  <p className="text-sm text-foreground-500">日均访问量</p>
                </div>
                <div className="bg-background-50 rounded-lg p-5 text-center">
                  <div className="text-3xl font-bold text-accent-500 font-heading mb-1">5000+</div>
                  <p className="text-sm text-foreground-500">累计原创文章</p>
                </div>
                <div className="bg-background-50 rounded-lg p-5 text-center">
                  <div className="text-3xl font-bold text-primary-500 font-heading mb-1">98%</div>
                  <p className="text-sm text-foreground-500">用户满意度</p>
                </div>
              </div>

              <div className="space-y-4">
                <h3 className="text-base font-bold text-foreground-950 font-heading">用户好评</h3>
                {[
                  { name: "吃瓜达人小王", text: "每天必须刷一遍，不然跟朋友都没话题聊了！更新速度真的快，很多独家爆料别的地方根本看不到。", rating: 5 },
                  { name: "娱乐观察家", text: "内容很全面，分类也很清晰。最喜欢他们的独家爆料栏目，经常能看到惊喜内容。强烈推荐！", rating: 5 },
                  { name: "路人甲", text: "朋友推荐的，一开始还觉得就是普通八卦网站，用了之后发现信息量真的很大，而且更新频率很高，现在已经离不开了。", rating: 5 },
                ].map((review, i) => (
                  <div key={i} className="bg-background-50 rounded-lg p-4 flex gap-4">
                    <div className="flex-shrink-0 w-10 h-10 rounded-full bg-primary-100 flex items-center justify-center">
                      <span className="text-sm font-bold text-primary-600 font-heading">
                        {review.name.charAt(0)}
                      </span>
                    </div>
                    <div className="flex-1 min-w-0">
                      <div className="flex items-center gap-2 mb-1">
                        <span className="text-sm font-medium text-foreground-900">{review.name}</span>
                        <div className="flex items-center">
                          {Array.from({ length: review.rating }).map((_, j) => (
                            <i key={j} className="ri-star-fill text-accent-500 text-xs w-3 h-3 flex items-center justify-center"></i>
                          ))}
                        </div>
                      </div>
                      <p className="text-sm text-foreground-600 leading-relaxed">{review.text}</p>
                    </div>
                  </div>
                ))}
              </div>
            </section>

            <section className="mb-12">
              <h2 className="text-xl md:text-2xl font-bold text-foreground-950 font-heading mb-6">
                📞 联系我们
              </h2>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 mb-8">
                <div className="bg-background-100 rounded-lg p-5 flex items-start gap-4">
                  <div className="w-10 h-10 flex-shrink-0 rounded-full bg-primary-100 flex items-center justify-center">
                    <i className="ri-mail-line text-primary-500 w-5 h-5 flex items-center justify-center"></i>
                  </div>
                  <div>
                    <h3 className="text-sm font-semibold text-foreground-950 mb-1">电子邮箱</h3>
                    <p className="text-sm text-foreground-600">contact@heiliachigua.com</p>
                  </div>
                </div>
                <div className="bg-background-100 rounded-lg p-5 flex items-start gap-4">
                  <div className="w-10 h-10 flex-shrink-0 rounded-full bg-accent-100 flex items-center justify-center">
                    <i className="ri-customer-service-2-line text-accent-500 w-5 h-5 flex items-center justify-center"></i>
                  </div>
                  <div>
                    <h3 className="text-sm font-semibold text-foreground-950 mb-1">客服时间</h3>
                    <p className="text-sm text-foreground-600">7×24小时全天候服务</p>
                  </div>
                </div>
              </div>

              <div className="bg-background-100 rounded-lg p-6 md:p-8">
                <h3 className="text-lg font-bold text-foreground-950 font-heading mb-2">在线留言</h3>
                <p className="text-sm text-foreground-500 mb-5">有任何问题或建议，欢迎给我们留言，我们会尽快回复。</p>

                {formStatus === "success" ? (
                  <div className="bg-primary-50 border border-primary-200 rounded-lg p-4 text-center">
                    <p className="text-primary-600 font-medium text-sm">✅ 留言已成功提交，感谢您的反馈！</p>
                  </div>
                ) : (
                  <form onSubmit={handleSubmit} data-readdy-form="" className="space-y-4">
                    <input
                      type="text"
                      name="company_alt"
                      className="honeypot-field"
                      tabIndex={-1}
                      autoComplete="off"
                      aria-hidden="true"
                      readOnly
                    />
                    <div>
                      <label htmlFor="about-name" className="block text-sm font-medium text-foreground-700 mb-1.5">
                        您的称呼 *
                      </label>
                      <input
                        id="about-name"
                        name="name"
                        type="text"
                        required
                        className="w-full px-4 py-2.5 rounded-lg border border-background-300 bg-background-50 text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-400 transition-all"
                        placeholder="请输入您的称呼"
                      />
                    </div>
                    <div>
                      <label htmlFor="about-email" className="block text-sm font-medium text-foreground-700 mb-1.5">
                        电子邮箱 *
                      </label>
                      <input
                        id="about-email"
                        name="email"
                        type="email"
                        required
                        className="w-full px-4 py-2.5 rounded-lg border border-background-300 bg-background-50 text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-400 transition-all"
                        placeholder="请输入您的邮箱"
                      />
                    </div>
                    <div>
                      <label htmlFor="about-message" className="block text-sm font-medium text-foreground-700 mb-1.5">
                        留言内容 *
                      </label>
                      <textarea
                        id="about-message"
                        name="message"
                        required
                        maxLength={500}
                        rows={4}
                        className="w-full px-4 py-2.5 rounded-lg border border-background-300 bg-background-50 text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-400 transition-all resize-none"
                        placeholder="请输入您的留言（最多500字）"
                      ></textarea>
                    </div>
                    {formStatus === "error" && formError && (
                      <div className="bg-accent-50 border border-accent-200 rounded-lg p-3">
                        <p className="text-accent-700 text-sm">{formError}</p>
                      </div>
                    )}
                    <button
                      type="submit"
                      className="w-full sm:w-auto px-6 py-2.5 rounded-full bg-primary-500 text-background-50 font-semibold text-sm hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer"
                    >
                      提交留言
                    </button>
                  </form>
                )}
              </div>
            </section>

            <section>
              <h2 className="text-xl md:text-2xl font-bold text-foreground-950 font-heading mb-6">
                ❓ 常见问题
              </h2>
              <div className="space-y-3">
                {faqData.map((faq, i) => (
                  <details key={i} className="bg-background-100 rounded-lg group cursor-pointer">
                    <summary className="px-5 py-4 text-sm font-medium text-foreground-900 list-none flex items-center justify-between">
                      {faq.question}
                      <i className="ri-arrow-down-s-line text-foreground-400 group-open:rotate-180 transition-transform w-4 h-4 flex items-center justify-center"></i>
                    </summary>
                    <div className="px-5 pb-4">
                      <p className="text-sm text-foreground-600 leading-relaxed">{faq.answer}</p>
                    </div>
                  </details>
                ))}
              </div>
            </section>
          </div>
        </main>
        <Footer />
      </div>
    </>
  );
}